import getUrlParameter from "helpers/getUrlParameter";
import Cookies from "js-cookie";
import safely from "utils/safeCookie";
const tags = ["pds", "pdm"];
// Mirrors PersistShareReferralTags (apps/api/app/Http/Middleware) TTL of 48 hours.
// Cookies.set expects days, not seconds.
const COOKIE_TTL_DAYS = 2;
// Query params write their own cookies client-side because a cached CDN response never reaches
// Laravel, so the server-side middleware that would otherwise set these cookies never runs.
export const persistShareReferral = () => {
    tags.forEach((key) => {
        const value = getUrlParameter(key);
        if (value) {
            safely(() => Cookies.set(`cookie_${key}`, value, {
                expires: COOKIE_TTL_DAYS, path: "/", secure: true, sameSite: "Lax",
            }), undefined);
        }
    });
};
const retrieve = () => {
    const items = {};
    tags.forEach((key) => {
        const urlValue = getUrlParameter(key);
        const value = urlValue || safely(() => Cookies.get(`cookie_${key}`), undefined);
        if (value) {
            items[key] = value;
        }
    });
    return items;
};
export default retrieve;
